import React from 'react'

const ChatbotAnswers = () => {
  return <div></div>;
}

export default ChatbotAnswers